










































































import { Component, Vue, Watch } from "vue-property-decorator";
import { resepStore } from "@/store/modules/resep";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { isEmpty } from "lodash";
import ResepStatusFarmasi from "@/components/pemeriksaan/resep-obat/ResepStatusFarmasi.vue";

@Component({
  components: {
    ResepStatusFarmasi,
  },
})
export default class CardListResepIgd extends Vue {
  resepText = "";
  activeResep = {};
  loading = false;

  get listResep() {
    return resepStore.resep.filter(item => item.unit.id == "01");
  }

  get isEditable() {
    return userModule.user.profesi === "Dokter";
  }

  get canAddResep() {
    return this.listResep.length && userModule.user.profesi === "Dokter";
  }

  @Watch("listResep", { deep: true })
  changedListResep() {
    this.resepText = "";
  }

  showResep(resep) {
    this.resepText = resep.text;
    this.activeResep = resep;

    this.$emit("set-active-resep", null);
  }

  editResep(resep) {
    if (resep.dokter.id == userModule.user.id) {
      this.$emit("set-active-resep", resep);
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat mengedit resep yang ditulis dokter lain"
      );
    }
  }

  addResep() {
    this.$emit("add-resep");
  }

  formatDate(date) {
    return new Intl.DateTimeFormat("id-ID", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    }).format(new Date(date));
  }

  isEmpty(val) {
    return isEmpty(val);
  }
}
